import {  ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
import { StateList } from '@/shared/statesList';

export interface SnbProfileStoreState {
}
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    getUserGroups(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-usergroup-details-for-user';
      return ApiServiceWrapper.get(endpoint);
    },
    getPreferenceDetails(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-user-preferences';
      return ApiServiceWrapper.get(endpoint);
    },
    getUserDetails(context: ActionContext<SnbProfileStoreState, RootStoreState>, userId : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/get-user-details?username=${userId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getCheckRights(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'sandbox/check-rights';
      return ApiServiceWrapper.get(endpoint);
    },
    getDCList(context: ActionContext<SnbProfileStoreState, RootStoreState>, userId : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/get-datacenter-details?username=${userId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getDefaultLandingPage(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-landing-applications';
      return ApiServiceWrapper.get(endpoint);
    },
    refreshIDPpasscode(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'refresh-idp-password';
      return ApiServiceWrapper.post(endpoint);
    },
    getSubscriptionCode(context: ActionContext<SnbProfileStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      let endpoint = '';
      if (payload.code === undefined) {
        endpoint = 'user';
      } else {
        endpoint = `users?subscriptioncode=${payload.code}&tempToken=${payload.tempToken1}`;
      }
      return ApiServiceWrapper.delete(endpoint);
    },
    updateBasicInfo(context: ActionContext<SnbProfileStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      // tslint:disable-next-line:max-line-length
      const endpoint = 'users/update-basicdetails';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getTimeZones(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/time-zone';
      return ApiServiceWrapper.get(endpoint);
    },
    updateTimeZone(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-timezone';
      return ApiServiceWrapper.post(endpoint, request);
    },
    getEmailSubscription(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-email-subscriptions';
      return ApiServiceWrapper.get(endpoint);
    },
    updateNotificationPrefs(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-notification-pref';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateEmailPreference(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/save-email-subscriptions';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateBetaSettings(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/update-betatester?betaTester=${request}`;
      return ApiServiceWrapper.get(endpoint);
    },
    updateEmail(context: ActionContext<SnbProfileStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-email';
      return ApiServiceWrapper.put(endpoint, payload);
    },
    validateRenewalContact(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/renewal-contact-exists?emailaddress=${request}&captchaText=''`;
      return ApiServiceWrapper.get(endpoint);
    },
    createRenewalContact(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/create-renewal-contact';
      return ApiServiceWrapper.post(endpoint, request);
    },
    getDistributorList(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-all-disty?emailAddress=${request}`;
      return ApiServiceWrapper.get(endpoint);
    },
    addDistryInfo(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/create-partner-disty';
      return ApiServiceWrapper.post(endpoint, request);
    },
    removeDistryInfo(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/delete-partner-disty';
      return ApiServiceWrapper.post(endpoint, request);
    },
    addTaxInfo(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading');
      const endpoint = 'users/create-partner-certificate';
      return ApiServiceWrapper.post(endpoint, request);
    },
    deleteTaxInfo(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/delete-partner-certificate';
      return ApiServiceWrapper.post(endpoint, request);
    },
    getAlternateEmailData(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-capture-atp-alternate-emailaddress';
      return ApiServiceWrapper.get(endpoint);
    },
    updateAlternateEmail(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-capture-atp-email';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateDefaultLanding(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-default-landing-application';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateUserDetails(context: ActionContext<SnbProfileStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users';
      return ApiServiceWrapper.put(endpoint, payload);
    },
    setPreferenceDetails(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/set-user-preferences';
      return ApiServiceWrapper.post(endpoint, request);
    },
    enableDomainCred(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'verify-domain-credentials';
      return ApiServiceWrapper.post(endpoint, request);
    },
    getUserList(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/get-user-list?bRecAdded=${request}`;
      return ApiServiceWrapper.get(endpoint);
    },
    viewOrRevokeOrGrant(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/manage-apikey';
      return ApiServiceWrapper.post(endpoint, request);
    },
    removeUser(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/delete-contact';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateAdminRole(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-admin-role';
      return ApiServiceWrapper.post(endpoint, request);
    },
    getCountriesFromServer(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-country?languageCode=EN&isWCM=${request}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getBillingAddress(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `quote/address/getBillingAddressInfo?addressid=${request}`;
      return ApiServiceWrapper.get(endpoint);
    },
    updateBillingInfo(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/update-billing-info';
      return ApiServiceWrapper.post(endpoint, request);
    },
    verifyAddress(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : any) {
      context.commit('startLoading', null, { root: true });
      const payload = {
        country: request.countryCode,
        city: request.city,
        address: request.address,
        zipCode: request.zipCode,
        state: request.stateCode,
        province: request.province,
        captchaText: request.captchaText,
      };
      const endpoint = 'users/verify-address';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    // tslint:disable-next-line:no-unused
    getStates(context: ActionContext<SnbProfileStoreState, RootStoreState>, payload: { [key: string]: string }) {
      return StateList[payload.countryCode];
    },
    updatePassword(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/change-password';
      return ApiServiceWrapper.post(endpoint, request);
    },
    setTFAPreference(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-tfa';
      return ApiServiceWrapper.post(endpoint, request);
    },
    verifyTFA(context: ActionContext<SnbProfileStoreState, RootStoreState>, req : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `verify-tfa?userlogin=${req.userlogin}&twofactorKeyCode=${req.twofactorKeyCode}&twofactorAuthMode=${req.twofactorAuthMode}&phoneNo=${req.phoneNo}&captchaText=${req.captchaText}&TFACode=${req.TFACode}&TFAID=${req.TFAID}`;
      return ApiServiceWrapper.get(endpoint);
    },
    updateRenewalDays(context: ActionContext<SnbProfileStoreState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-renewal-day';
      return ApiServiceWrapper.post(endpoint, request);
    },
    refreshPassword(context: ActionContext<SnbProfileStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'refresh-idp-password';
      return ApiServiceWrapper.post(endpoint, { oemCode: '' });
    },
    // tslint:disable-next-line:no-unused
    metadataExchange(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'process-idp-metadata';
      return ApiServiceWrapper.post(endpoint, request);
    },
    // tslint:disable-next-line:no-unused
    deleteRenewalContact(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : any) {
      // context.commit('startLoading', null, { root: true });
      const endpoint = 'users/delete-renewal-contact';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateFlexspendAccess(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-flexspend-role';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateMsspAccess(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-mssp-role';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateMswRole(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-MSW-role';
      return ApiServiceWrapper.post(endpoint, request);
    },
    addNewUser(context: ActionContext<SnbProfileStoreState, RootStoreState>, request : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/add-user';
      return ApiServiceWrapper.post(endpoint, request);
    },
  },
  getters: {
  },
  namespaced: true,
} as Module<SnbProfileStoreState, RootStoreState>;
